import CornyBakersEnvironment from "../domain/CornyBakersEnvironment";

export const CornyBakersEnv: CornyBakersEnvironment = {
    HOME_PAGE: '/',
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL ?? ""
};